module.exports = __webpack_public_path__ + "67e2210c8eaabb45e3dffad9f22ff729.jpg";